import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './styles.css';
import { convertToVNDate } from '../../helpers';

export default function ProductHorizontal(props = {}) {
    const { isSideBar, path, image, title, createdAt, summary } = props;

    return (
        <div
            className="post d-flex align-items-center"
            data-aos="zoom-in"
            data-aos-delay="100"
        >
            <div className="pic">
                <img src={image} className="img-fluid" alt={title} />
            </div>
            <div className="post-info">
                <Link to={path} className="text-decoration-none"><h4>{title}</h4></Link>
                <span>{convertToVNDate(createdAt)}</span>
                {!isSideBar && <p>{summary}</p>}
                <Link to={path} className="d-flex justify-content-end align-items-center text-decoration-none mt-2 me-3">
                    <b>Read More</b>&nbsp;<i className="fa fa-long-arrow-right pt-1" aria-hidden="true"></i>
                </Link>
            </div>
        </div>
    )
}

ProductHorizontal.propTypes = {
    path: PropTypes.string.isRequired,
    isSideBar: PropTypes.bool,
    type: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    summary: PropTypes.string,
}